import { CostPerRoomData } from '../constants/types';
import { monthNames } from "../constants/monthNames";
export const fetchCostPerRoomData = async (token: string, year: number) => {
  if (!token) 
    return;
    try {
      const response = await fetch(`https://qjy74sxgt8.execute-api.us-east-2.amazonaws.com/prod/cost-per-room?year=${year}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        },
      });

      if (!response.ok) throw new Error("Failed to fetch API data");

      const rawData = await response.json();

      const formattedData: CostPerRoomData[] = rawData.map((item: any) => ({
      year: item.year,
      month: monthNames[parseInt(item.month) - 1] ?? item.month,
      cpr_fields: {
        cogs: item['cpr-fields'].cogs,
        cs_salary: item['cpr-fields']['cs-salary'],
        hardware: item['cpr-fields'].hardware,
        no_of_rooms: item['cpr-fields']['no-of-rooms']
      }
    }));

      console.log("Raw API Response:", rawData);
      return formattedData;
  } catch (error) {
    console.error('Error fetching Cost Per Room data:', error);
    return null;
  }
};